import { getContactMessages, getWhatsAppUrl } from '../config/contact';
import { useI18n } from '../i18n';
import SpotlightSurface from './SpotlightSurface';

const iconPaths = {
  sites: 'M5 4h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2ZM3 9h18M7 6.5h.01M10 6.5h.01M7 13h5M7 16h10',
  sistemas: 'M4 3h6v6H4zM14 15h6v6h-6zM4 15h6v6H4zM7 9v3h10v3M7 12v3M14 4h6M17 1v6',
  agendamentos: 'M6 5h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2ZM8 3v4M16 3v4M4 10h16M8 14h3M8 17h7',
  automacoes: 'M3 3h6v6H3zM15 15h6v6h-6zM9 6h6a3 3 0 0 1 3 3v3M15 9l3 3 3-3M15 18H9a3 3 0 0 1-3-3v-3M3 15l3-3 3 3',
};

const ServiceIcon = ({ type }) => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
    <path d={iconPaths[type]} />
  </svg>
);

const Services = () => {
  const { locale, t } = useI18n();
  const messages = getContactMessages(locale);
  const services = t.services.items;
  return (
  <section id="solucoes" className="solutions" tabIndex={-1} aria-labelledby="services-title">
    <div className="container">
      <div className="section-header services-heading">
        <div>
          <p className="eyebrow">{t.services.eyebrow}</p>
          <h2 id="services-title">{t.services.title}</h2>
        </div>
        <p className="services-intro">{t.services.intro}</p>
      </div>
      <div className="solutions-grid">
        {services.map((service, index) => (
          <article className={`solution-card service-card--${service.id}`} key={service.id} aria-labelledby={`service-${service.id}-title`}>
            <div className="service-card-top" aria-hidden="true">
              <span className="service-icon"><ServiceIcon type={service.id} /></span>
              <span className="service-index">0{index + 1}</span>
            </div>
            <h3 id={`service-${service.id}-title`}>{service.title}</h3>
            <p className="service-problem">{service.problem}</p>
            <div className="service-description">
              <p className="service-label">{t.services.solutionLabel}</p>
              <p>{service.solution}</p>
            </div>
            <div className="service-benefits">
              <p className="service-label">{service.listLabel}</p>
              <ul className="service-highlights">
                {service.highlights.map((highlight) => <li key={highlight}>{highlight}</li>)}
              </ul>
            </div>
            <p className="service-scope">{service.scope}</p>
            <a className="section-link service-contact-link" href={getWhatsAppUrl(service.message)} target="_blank" rel="noopener noreferrer">
              {service.contactLabel}<span aria-hidden="true">↗</span>
            </a>
          </article>
        ))}
      </div>
      <SpotlightSurface className="cta-inline services-contact" id="cta-solucoes">
        <div className="services-contact-copy">
          <h3>{t.services.contactTitle}</h3>
          <p>{t.services.contactDescription}</p>
        </div>
        <a href={getWhatsAppUrl(messages.services)} target="_blank" rel="noopener noreferrer" className="btn-primary">{t.services.contactCta} <span aria-hidden="true">↗</span></a>
      </SpotlightSurface>
    </div>
  </section>
  );
};

export default Services;
